'use client'

import { useRef } from 'react'
import { QuestionmarkCircleIcon } from '@navikt/aksel-icons'
import { BodyLong, Heading, Link, Modal } from '@navikt/ds-react'
import { LinkButton } from '@/components/link-button/LinkButton'
import { Texts } from '@/texts/getTexts'

export default function FagligModal({ t }: { t: Texts['footer'] }) {
    const ref = useRef<HTMLDialogElement>(null)
    const tb = t.arbeidsgiver.brukerstoette

    return (
        <>
            <LinkButton onClick={() => ref.current?.showModal()}>{t.brukerstoette}</LinkButton>
            <Modal
                ref={ref}
                closeOnBackdropClick
                header={{
                    heading: t.brukerstoette,
                    icon: <QuestionmarkCircleIcon aria-hidden />,
                }}
            >
                <Modal.Body>
                    <Heading level="2" size="small" spacing>
                        {tb.altinnHeading}
                    </Heading>
                    <BodyLong spacing>
                        {tb.altinnBefore}
                        <Link href="https://info.altinn.no/hjelp/" target="_blank" rel="noopener noreferrer">
                            {tb.altinnLink}
                        </Link>
                        {tb.altinnAfter}
                        <Link href="https://www.altinn.no/" target="_blank" rel="noopener noreferrer">
                            {tb.altinnKildeLink}
                        </Link>
                        {tb.altinnKildeAfter}
                    </BodyLong>

                    <Heading level="2" size="small" spacing>
                        {tb.aMeldingHeading}
                    </Heading>
                    <BodyLong spacing>
                        {tb.aMeldingBefore}
                        <Link
                            href="https://www.skatteetaten.no/bedrift-og-organisasjon/arbeidsgiver/a-meldingen/veiledning/feilmeldinger-magnetedag-og-tilbakemelding/oversikt-over-feilmeldinger-magnetedag/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {tb.aMeldingVeiledningLink}
                        </Link>
                        {tb.aMeldingMellom}
                        <Link
                            href="https://www.skatteetaten.no/bedrift-og-organisasjon/arbeidsgiver/a-meldingen/om-a-ordningen/kontakt-a-ordningen/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {tb.aMeldingKontaktLink}
                        </Link>
                        {tb.aMeldingAfter}
                        <Link href="https://www.skatteetaten.no/" target="_blank" rel="noopener noreferrer">
                            {tb.aMeldingKildeLink}
                        </Link>
                        {tb.aMeldingKildeAfter}
                    </BodyLong>

                    <Heading level="2" size="small" spacing>
                        {tb.andreHeading}
                    </Heading>
                    <BodyLong>
                        {tb.andreBefore}
                        <Link href="https://www.nav.no/arbeidsgiver/aa-registeret" target="_blank" rel="noopener noreferrer">
                            {tb.andreLink}
                        </Link>
                        {tb.andreMellom}
                        <Link href="https://www.nav.no/kontor/nav-registerforvaltning" target="_blank" rel="noopener noreferrer">
                            {tb.andreKontaktLink}
                        </Link>
                        {tb.andreAfter}
                    </BodyLong>
                </Modal.Body>
            </Modal>
        </>
    )
}
